import React, { Component } from 'react';
import './FAQ.scss';

export default class FAQ extends Component {
  render() {
    return (
      <div className={"faq"}>
          <h1>FAQ</h1>
      </div>
    )
  }
}
